// src/components/ui/TitleBar.js
import React from 'react';

const TitleBar = ({
  icon = '📌',
  title = '',
  accent = '#39FF14',
  right = null,
  subtitle = '',
  wrapStyle = {},
  innerStyle = {},
  titleStyle = {},
  iconStyle = {},
  rightStyle = {},
  topRow = null
}) => {
  const isMobile = typeof window !== 'undefined' ? window.innerWidth < 1024 : false;

  return (
    <div
      style={{
        background: 'white',
        border: '10px solid black',
        padding: isMobile ? '10px 12px' : '14px 16px',
        marginBottom: '16px',
        boxSizing: 'border-box',
        width: '100%',
        ...wrapStyle
      }}
    >
      {topRow}
      <div
        style={{
          border: `3px solid ${accent}`,
          background: 'white',
          padding: '12px 14px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '12px',
          // ✅ Desktop: keep everything in one row.
          // ✅ Mobile: allow wrapping so buttons can stack if needed.
          flexWrap: isMobile ? 'wrap' : 'nowrap',
          borderRadius: '10px',
          boxSizing: 'border-box',
          width: '100%',
          ...innerStyle
        }}
      >
        {/* LEFT: icon + title */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            minWidth: 0,
            flex: '1 1 auto' // ✅ take remaining space but allow shrink
          }}
        >
          <div
            style={{
              width: '44px',
              height: '44px',
              border: '4px solid black',
              background: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '10px',
              flex: '0 0 auto',
              ...iconStyle
            }}
          >
            <span style={{ fontSize: isMobile ? '18px' : '22px', lineHeight: 1 }}>{icon}</span>
          </div>

          <div style={{ minWidth: 0 }}>
            <div
              style={{
                fontWeight: 900,
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                fontSize: isMobile ? '20px' : '28px',
                lineHeight: 1.1,
                whiteSpace: isMobile ? 'normal' : 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                ...titleStyle
              }}
              title={title}
            >
              {title}
            </div>

            {subtitle ? (
              <div
                style={{
                  marginTop: '4px',
                  fontWeight: 900,
                  textTransform: 'uppercase',
                  fontSize: '12px',
                  opacity: 0.75,
                  letterSpacing: '0.4px',
                  whiteSpace: isMobile ? 'normal' : 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
                title={subtitle}
              >
                {subtitle}
              </div>
            ) : null}
          </div>
        </div>

        {/* RIGHT: buttons */}
        {right ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              flex: isMobile ? '1 1 100%' : '0 0 auto',
              flexWrap: 'wrap',
              justifyContent: isMobile ? 'center' : 'flex-end',
              maxWidth: isMobile ? '100%' : 'none',
              ...rightStyle
            }}
          >
            {right}
          </div>
        ) : (
          <div style={{ flex: '0 0 auto' }} />
        )}
      </div>
    </div>
  );
};

export default TitleBar;
